import React from "react";
import { Link } from "react-router-dom";
import classes from "./cart-header.module.scss";

const CartHeader = ({ item, symbol, removeFromMiniCart }) => {
    const inr = new Intl.NumberFormat("en-IN", { style: "decimal" });

    const CartimgeSource = (item) => {
        let images = [];
        let imgeSrc = [];
        let imgI = 0;
        const exts = [".png", ".jpg", ".webp", ".gif"];
        if (item.selectedVariant.image) {
            let allImages = item.selectedVariant.image;
            images = allImages.split(",");
            images.forEach(function (img) {
                let ext = img.substring(img.lastIndexOf("."));

                if (exts.includes(ext)) {
                    imgeSrc[imgI] = img;
                    imgI++;
                }
            });
        }
        return imgeSrc[0];
    };

    const removeFromCart = (item) => {
        removeFromMiniCart(item, item.selectedVariant);
    };

    const img_fallback = (event) => {
        event.target.parentNode.childNodes.forEach(function (node) {
            if (node.nodeName == "IMG") node.src = window.no_image;
        });
    };

    return (
        <div className={classes.cart_item}>
            <Link
                className={classes.cart_item_link}
                to={`${process.env.PUBLIC_URL}/cart`}
            >
                <figure>
                    <img
                        src={`${CartimgeSource(item)}?resize=88,88&compress=50`}
                        onError={img_fallback}
                        className="img-fluid lazyload bg-img"
                        alt="products on cart"
                    />
                </figure>
                <div className={classes.cart_content}>
                    <h5 className={classes.item_title}>{item.name}</h5>
                    {item.selectedVariant && (
                        <div className={classes.variants}>
                            <p
                                className={classes.variant_item}
                            >
                                {item.selectedVariant.color.replace("-", " ").toUpperCase()}
                            </p>
                            {item.selectedVariant.size > 0 && (
                                <p
                                    className={classes.variant_item}
                                >
                                    {item.selectedVariant.size}
                                </p>)}
                        </div>
                    )}
                    <h4 className={classes.cart_sum}>
                        {item.qty} x
                        <span>
                            {symbol} {inr.format(item.variant.offerprice)}
                        </span>
                    </h4>
                </div>
            </Link>
            <div className={classes.close_circle}>
                <a
                    href={null}
                    onClick={() => {
                        removeFromCart(item);
                    }}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
                        <path d="M10.3542 0.509766L0.354174 10.5098M0.353516 0.353516L10.3535 10.3535" stroke="black" />
                    </svg>
                </a>
            </div>
        </div>
    );
};

export default CartHeader;
